import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var inputShared = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_19zjrzw0',variantClassNames:{state:{'default':'fx_2d2fb1e5_19zjrzw1',error:'fx_2d2fb1e5_19zjrzw2'}},defaultVariants:{state:'default'},compoundVariants:[]});

export { inputShared };
//# sourceMappingURL=shared.vanilla.mjs.map
